const CalendarIcon = ({
  size = 16,
  color = "#6A7282",
  strokeWidth = 1.66,
  isActive = false,
}) => {
  const activeColor = isActive ? "#dc2626" : color;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33333 4.66667V2
           M10.6667 4.66667V2
           M4.66667 7.33333H11.3333
           M3.33333 14H12.6667
           C13.0203 14 13.3594 13.8595 13.6095 13.6095
           C13.8595 13.3594 14 13.0203 14 12.6667V4.66667
           C14 4.31304 13.8595 3.97391 13.6095 3.72386
           C13.3594 3.47381 13.0203 3.33333 12.6667 3.33333H3.33333
           C2.97971 3.33333 2.64057 3.47381 2.39052 3.72386
           C2.14048 3.97391 2 4.31304 2 4.66667V12.6667
           C2 13.0203 2.14048 13.3594 2.39052 13.6095
           C2.64057 13.8595 2.97971 14 3.33333 14Z"
        stroke={activeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CalendarIcon;
